function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 64 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0566657,-6.93954e-18,6.93689e-18,-0.056644,61.8492,27.8778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M474.023,260.978L165.107,260.978C156.287,260.978 149.129,253.82 149.129,245C149.129,236.18 156.287,229.022 165.107,229.022L474.023,229.022C482.843,229.022 490.001,236.18 490.001,245C490.001,253.82 482.843,260.978 474.023,260.978Z",
    style: {
      fill: "rgb(223,43,43)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.327,346.194C246.235,346.194 242.147,344.642 239.034,341.509L153.818,256.293C147.577,250.048 147.577,239.929 153.818,233.687L239.034,148.471C245.276,142.23 255.395,142.23 261.64,148.471C267.882,154.713 267.882,164.832 261.64,171.073L187.713,245L261.64,318.927C267.882,325.168 267.882,335.287 261.64,341.529C258.508,344.642 254.416,346.194 250.327,346.194Z",
    style: {
      fill: "rgb(223,43,43)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.349,479.349C105.138,479.349 0,374.211 0,245C0,115.789 105.138,10.651 234.349,10.651C331.303,10.651 416.905,68.982 452.463,159.273C455.7,167.473 451.651,176.741 443.451,179.999C435.248,183.197 425.979,179.211 422.722,170.968C392.021,92.992 318.075,42.607 234.349,42.607C122.755,42.607 31.957,133.41 31.957,245C31.957,356.59 122.755,447.393 234.349,447.393C318.075,447.393 392.021,397.008 422.722,319.055C425.96,310.809 435.228,306.826 443.451,310.021C451.651,313.259 455.7,322.547 452.463,330.751C416.905,421.018 331.303,479.349 234.349,479.349Z",
    style: {
      fill: "rgb(223,43,43)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0566657,-6.93954e-18,6.93689e-18,-0.056644,29.7133,27.8778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M474.023,260.978L165.107,260.978C156.287,260.978 149.129,253.82 149.129,245C149.129,236.18 156.287,229.022 165.107,229.022L474.023,229.022C482.843,229.022 490.001,236.18 490.001,245C490.001,253.82 482.843,260.978 474.023,260.978Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.327,346.194C246.235,346.194 242.147,344.642 239.034,341.509L153.818,256.293C147.577,250.048 147.577,239.929 153.818,233.687L239.034,148.471C245.276,142.23 255.395,142.23 261.64,148.471C267.882,154.713 267.882,164.832 261.64,171.073L187.713,245L261.64,318.927C267.882,325.168 267.882,335.287 261.64,341.529C258.508,344.642 254.416,346.194 250.327,346.194Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.349,479.349C105.138,479.349 0,374.211 0,245C0,115.789 105.138,10.651 234.349,10.651C331.303,10.651 416.905,68.982 452.463,159.273C455.7,167.473 451.651,176.741 443.451,179.999C435.248,183.197 425.979,179.211 422.722,170.968C392.021,92.992 318.075,42.607 234.349,42.607C122.755,42.607 31.957,133.41 31.957,245C31.957,356.59 122.755,447.393 234.349,447.393C318.075,447.393 392.021,397.008 422.722,319.055C425.96,310.809 435.228,306.826 443.451,310.021C451.651,313.259 455.7,322.547 452.463,330.751C416.905,421.018 331.303,479.349 234.349,479.349Z",
    style: {
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.9ad6bec0d58730bbab3dea7c77ca4f3b.svg";
export { ForwardRef as ReactComponent };